import ReactMarkdown from 'react-markdown';

/**
 * Minimal markdown renderer with Tailwind prose styling. We intentionally
 * don't enable raw HTML or external link rewriting — content comes from
 * admins typing into the Workshop, but defensiveness is cheap.
 */
export default function Markdown({ children }: { children: string }) {
  if (!children?.trim()) {
    return <span className="text-gray-400 dark:text-gray-500 italic text-xs">Nothing here yet.</span>;
  }
  return (
    <div className="prose prose-sm dark:prose-invert max-w-none prose-headings:my-2 prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-pre:my-1 prose-code:text-xs">
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
